import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { changeQrMode, getQrMode } from "../../api/qrWorkflowMode";
import useQrOverlayVisibility from "./useQrOverlayVisibility";

export default function QrWorkflowModeControl() {
  const [mode, setMode] = useState(null);
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [overlayVisible, setOverlayVisible] = useQrOverlayVisibility();

  useEffect(() => {
    let active = true;
    getQrMode().then(value => { if (active) setMode(value); }).catch(() => { if (active) setError("Unable to load the current QR workflow flow."); });
    const ready = event => { if (active) { setMode(event.detail); setError(""); } };
    window.addEventListener("qr-mode-ready", ready);
    return () => { active = false; window.removeEventListener("qr-mode-ready", ready); };
  }, []);

  if (!mode || mode.environment !== "UAT" || mode.locked) return null;

  const selectTarget = next => {
    if (!mode || busy || next === mode.dataMode) return;
    setError("");
    setTarget(next);
  };
  const change = async () => {
    setBusy(true);
    setError("");
    try { await changeQrMode(mode, target); }
    catch (e) {
      setError(e.response?.data?.error || "Unable to change the QR workflow flow. Refresh and try again.");
      setBusy(false);
    }
  };

  return <>
    <section className="php-card qr-workflow-mode-card">
      <div className="qr-workflow-mode-copy">
        <span className="qr-workflow-mode-eyebrow">UAT environment</span><h2>QR Workflow Flow</h2>
        <p>Choose which workflow data the Asset QR Code <strong>Test</strong> action uses.</p>
        <label className="qr-overlay-visibility-toggle">
          <input type="checkbox" role="switch" checked={overlayVisible} onChange={event => setOverlayVisible(event.target.checked)} />
          <span>Show QR flow overlay<small>Display the current flow while testing. Saved for this browser.</small></span>
        </label>
        {error && <div className="qr-workflow-mode-error" role="alert">{error}</div>}
      </div>
      <div className="qr-workflow-mode-toggle" role="group" aria-label="QR workflow flow">
        <button type="button" className={mode?.dataMode === "TEST" ? "active" : ""} aria-pressed={mode?.dataMode === "TEST"} disabled={!mode || busy} onClick={() => selectTarget("TEST")}><strong>UAT Flow</strong><span>QR test data</span></button>
        <button type="button" className={mode?.dataMode === "PRODUCTION" ? "active production" : ""} aria-pressed={mode?.dataMode === "PRODUCTION"} disabled={!mode || busy} onClick={() => selectTarget("PRODUCTION")}><strong>Production Flow</strong><span>Live production data</span></button>
      </div>
    </section>
    <Modal show={target !== null} onHide={() => !busy && setTarget(null)} centered backdrop="static" className="qr-workflow-mode-modal">
      <Modal.Header closeButton={!busy}><Modal.Title>Switch to {target === "TEST" ? "UAT Flow" : "Production Flow"}?</Modal.Title></Modal.Header>
      <Modal.Body><p>{target === "PRODUCTION" ? "UAT QR actions will read and write live Production driver workflow data." : "UAT QR actions will use the isolated QR test data."}</p><p>This changes the flow for the entire UAT application. Existing driver workflows expire and must be entered or scanned again. Open forms and reports will reload.</p>{error && <div className="qr-workflow-mode-error" role="alert">{error}</div>}</Modal.Body>
      <Modal.Footer><button type="button" className="secondary" disabled={busy} onClick={() => setTarget(null)}>Cancel</button><button type="button" className={target === "PRODUCTION" ? "production" : ""} disabled={busy} onClick={change}>{busy ? "Switching…" : "Confirm switch"}</button></Modal.Footer>
    </Modal>
  </>;
}
